// @flow
import type { State, Action } from '../types';

import {
  REFRESH_TOKEN_REQUESTING,
  LOGIN_FAILED,
  ACCESS_TOKEN_REQUESTING,
  LOGIN_SUCCESS,
  UPDATE_TOKENS,
  LOGOUT
} from './constants';

const initialState: State = {
  accessToken: null,
  refreshToken: null,
  requesting: false,
  error: undefined
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case REFRESH_TOKEN_REQUESTING:
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        requesting: true,
        error: undefined
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        requesting: false,
        error: undefined,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken
      };
    case ACCESS_TOKEN_REQUESTING:
      return {
        ...state,
        requesting: true,
        error: undefined
      };
    case LOGIN_FAILED:
      return {
        ...state,
        requesting: false,
        error: { password: [action.error?.error_description] }
      };
    case UPDATE_TOKENS:
      return {
        ...state,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken
      };
    case LOGOUT:
      return {
        accessToken: null,
        refreshToken: null,
        requesting: false,
        error: undefined
      };
    default:
      return state;
  }
};

export default reducer;
